const FormatCreationDate = (inputTimestamp) => {
	const date = new Date(inputTimestamp);
	const day = String(date.getUTCDate()).padStart(2, '0');
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	const monthIndex = date.getUTCMonth();
	const monthName = months[monthIndex];
	const year = String(date.getUTCFullYear());

	const formattedDate = `${day} ${monthName} ${year}`;
	return formattedDate;
};

export default FormatCreationDate;
